import { render, staticRenderFns } from "./BlogRightSidebarTwo.vue?vue&type=template&id=3ce0ff37&"
import script from "./BlogRightSidebarTwo.vue?vue&type=script&lang=js&"
export * from "./BlogRightSidebarTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports